export enum Estado {
  ACTIVO = "Activo",
  INACTIVO = "Inactivo",
  ELIMINADO = "Eliminado",
  VENCIDO = "Vencido",
  RECHAZADO = "Rechazado",
  EXITOSO = "Exitoso",
}

export interface iDataEstado {
  id_estado: string;
  nombre: Estado;
  descripcion: string;
  created_at: string;
  updated_at: string;
}
